import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

const Blog = () => {
  const { t } = useTranslation();
  // Εδώ θα ήταν το array με τα articles αν υπήρχαν
  const articles = [];

  return (
    <>
      <Helmet>
        <title>{t("meta_title_blog")}</title>
        <meta name="description" content={t("meta_description")} />
        <link rel="alternate" hrefLang="en" href="brainstorm-visions.com/en" />
        <link rel="alternate" hrefLang="el" href="brainstorm-visions.com/el" />
      </Helmet>
      <Container sx={{ py: 7, minHeight: "70vh" }}>
        <Typography
          variant="h3"
          fontWeight="bold"
          mb={5}
          align="center"
          sx={{
            letterSpacing: 1.2,
            color: "primary.main",
            textShadow: "0 2px 8px #4a90e233"
          }}
          component={motion.div}
          initial={{ opacity: 0, y: -35 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {t("blog_page")}
        </Typography>
        {articles.length === 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 8 }}>
            <Paper
              elevation={4}
              sx={{
                p: 4,
                borderRadius: 4,
                background: "linear-gradient(120deg, #e0ecf7 60%, #fff 100%)",
                maxWidth: 420,
                textAlign: "center"
              }}
              component={motion.div}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <NewspaperIcon sx={{ fontSize: 64, color: "#57a1d8", mb: 2 }} />
              <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
                {t("no_articles")}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {t("no_articles_sub")}
              </Typography>
            </Paper>
          </Box>
        ) : (
          // Εδώ βάλε την εμφάνιση των άρθρων σου όταν υπάρχουν
          <Typography>Articles will go here</Typography>
        )}
      </Container>
    </>
  );
};

export default Blog;
